import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useForkRef, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useUpdateEffect } from '../../../internal/hooks';
import { DropdownPopover } from '../../../popover';
import { SelectInput, useControlledValue } from '../../internal';
import { useMultiSelectDesktopController } from './useMultiSelectDesktopController';
import { MultiSelectDesktopDropdown } from './MultiSelectDesktopDropdown';
import { processMultiSelectKeyboardEvent } from './processMultiSelectKeyboardEvent';

/**
 * select-компонент для выбора нескольких значений из списка
 *
 * Только десктопный вариант, открывающий выпадающий список
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectDesktop = /*#__PURE__*/React.forwardRef(function MultiSelectDesktop(props, forwardedRef) {
  const {
      onClick
    } = props,
    selectInputProps = _objectWithoutProperties(props, _excluded);
  const inputRef = React.useRef(null);
  const ref = useForkRef(forwardedRef, inputRef);
  const {
    value,
    onChange
  } = useControlledValue(props, []);
  const {
    open,
    focusedIndex,
    actions,
    allOptionLabel
  } = useMultiSelectDesktopController(_objectSpread(_objectSpread({}, props), {}, {
    value: value || [],
    onChange
  }));
  useUpdateEffect(() => {
    const inputNode = inputRef.current;
    if (!open && inputNode) {
      inputNode.focus();
    }
  }, [open], useIsomorphicLayoutEffect);
  const handleInputClick = React.useCallback(e => {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      e.stopPropagation();
      actions.toggleDropdown();
    }
  }, [actions, onClick]);
  const handleKeyDown = React.useCallback(e => {
    processMultiSelectKeyboardEvent(e, {
      open,
      actions
    });
  }, [open, actions]);
  return /*#__PURE__*/_jsx(DropdownPopover, {
    open: open,
    content: /*#__PURE__*/_jsx(MultiSelectDesktopDropdown, _objectSpread(_objectSpread({}, props), {}, {
      value: value,
      open: open,
      onKeyDown: handleKeyDown,
      focusedIndex: focusedIndex,
      actions: actions,
      allOptionLabel: allOptionLabel,
      insideRefs: [inputRef]
    })),
    children: /*#__PURE__*/_jsx(SelectInput, _objectSpread(_objectSpread({}, selectInputProps), {}, {
      ref: ref,
      open: open,
      onClick: handleInputClick,
      onKeyDown: handleKeyDown,
      role: "button",
      "aria-haspopup": "listbox",
      value: value
    }))
  });
});